import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/arrow-left.svg'
import _imports_1 from '@/assets/svg/mobile/shevron-left.svg'


const _withScopeId = n => (_pushScopeId("data-v-4e46a535"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text" }
const _hoisted_2 = { class: "arrow" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1
}

import { withDefaults } from 'vue';
import { useRouter } from 'vue-router';
import { useWindowSize } from '@vueuse/core';
import BaseTypography from './BaseTypography.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseReturn',
  props: {
    text: { default: 'Назад' }
  },
  setup(__props: any) {



const { width } = useWindowSize();
const router = useRouter();

const onNavigate = async (path: string) => router.push({ path });

const goBack = () => {
    const currentRoute = router.currentRoute.value.path;
    const rootPath = '/';

    if (currentRoute === rootPath) {
        return;
    }

    const newPath = currentRoute.substring(0, currentRoute.lastIndexOf('/'));

    const finalPath = newPath !== '' ? newPath : rootPath;

    return onNavigate(finalPath);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "return",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BaseTypography, {
        text: _ctx.text,
        type: _unref(width) > 768 ? 'subtitle' : 'subtitle-m',
        class: "max-w-[191px] l:max-w-max"
      }, null, 8, ["text", "type"]),
      _createElementVNode("div", _hoisted_2, [
        (_unref(width) > 768)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : (_openBlock(), _createElementBlock("img", _hoisted_4))
      ])
    ])
  ]))
}
}

})